import React, { useEffect, useState } from 'react';
import InputRange, { Range } from 'react-input-range';
import { RangeFilterCategory } from '../types';
import FilterCategory from './filterCategory';
import { useDispatch } from 'react-redux';
import { updatePrice } from '../filterListSlice';
import { isRangeValue } from '../utils';

interface FilterProps {
  category: RangeFilterCategory;
  index: number;
}

const PriceFilter = ({ category, index }: FilterProps) => {
  const [state, setState] = useState<Range>({
    min: category ? category.min : 0,
    max: category ? category.max : 0,
  });

  useEffect(() => {
    const categoryMinMaxReset = () =>
      category.min === category.activeMin &&
      category.max === category.activeMax;
    const stateNotMatchingCategory = () =>
      state.min !== category.min || state.max !== category.max;
    if (categoryMinMaxReset() && stateNotMatchingCategory()) {
      const { min, max } = category;
      setState({
        min,
        max,
      });
    }
  }, [category]);

  const dispatch = useDispatch();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    prop: string,
  ) => {
    const val: number = Number(e.target.value);
    if (val.toString().length <= category.max.toString().length) {
      setState((prev) => ({
        ...prev,
        [prop]: val,
      }));
    }
  };

  const submitInput = () => {
    if (
      category.min <= state.min &&
      category.max >= state.max &&
      state.min < state.max
    ) {
      dispatch(
        updatePrice({
          index,
          ...state,
        }),
      );
    }
  };

  return category && state ? (
    <FilterCategory
      icon={category.icon}
      name={category.name}
      index={index}
      closed={category.closed}
    >
      <div className='tour__filter__range'>
        <input
          type='number'
          min={category.min}
          max={category.max}
          onKeyDown={(e) => {
            e.key === 'Enter' ? submitInput() : false;
          }}
          onBlur={submitInput}
          onChange={(e) => handleChange(e, 'min')}
          className='tour__filter__range-min'
          value={state.min}
        />
        <input
          type='number'
          min={category.min}
          max={category.max}
          onKeyDown={(e) => {
            e.key === 'Enter' ? submitInput() : false;
          }}
          onBlur={submitInput}
          onChange={(e) => handleChange(e, 'max')}
          className='tour__filter__range-max'
          value={state.max}
        />
        <div className='tour__filter__range-slider'>
          <InputRange
            maxValue={category.max}
            minValue={category.min}
            formatLabel={(val) => `${val}`}
            value={state}
            onChange={(val: Range | number) => {
              if (isRangeValue(val)) {
                setState((prevState: Range) => {
                  return {
                    ...prevState,
                    min: val.min,
                    max: val.max,
                  };
                });
              }
            }}
            onChangeComplete={() => dispatch(updatePrice({ index, ...state }))}
          />
        </div>
      </div>
    </FilterCategory>
  ) : null;
};

export default PriceFilter;
